import { Accordion } from "@mantine/core";

import FooterBackGroundImage from "../../assets/png/error-page-decoration.png";

import LinkButton from "../../components/global/Button/LinkButton/LinkButton";
import useTranslation from "../../hooks/useTranslation";
import styles from "./FAQPage.module.scss";

type Question = {
  key: string;
  title: string;
  answer: string;
};

export const FAQPage = () => {
  const { t } = useTranslation();

  const questions: Question[] = [
    {
      key: "animations",
      title: t('faq.questions.animations.title'),
      answer: t('faq.questions.animations.answer'),
    },
    {
      key: "difference",
      title: t('faq.questions.difference.title'),
      answer: t('faq.questions.difference.answer'),
    },
    {
      key: "changePlanning",
      title: t('faq.questions.changePlanning.title'),
      answer: t('faq.questions.changePlanning.answer'),
    },
    {
      key: "workClothes",
      title: t('faq.questions.workClothes.title'),
      answer: t('faq.questions.workClothes.answer'),
    },
    {
      key: "trainees",
      title: t('faq.questions.trainees.title'),
      answer: t('faq.questions.trainees.answer'),
    },
    // {
    //   key: "difficulties",
    //   title: t('faq.questions.difficulties.title'),
    //   answer: t('faq.questions.difficulties.answer'),
    // },
  ];

  return (
    <article className={styles.faqPage}>
      <header className={styles.faqPage__headers}>
        {/* <h1>{t('faq.title')}</h1> */}
        <h2>{t('faq.description')}</h2>
      </header>
      <main className={styles.faqPage__questions}>
        <Accordion
          defaultValue={["question0"]}
          className={styles.faqPage__questions__accordion}
          multiple={true}
        >
          {questions.map((question, index) => {
            return (
              <Accordion.Item
                value={`question${index}`}
                key={`FAQ_question_index_${index}`}
              >
                <Accordion.Control>{question.title}</Accordion.Control>
                <Accordion.Panel>{question.answer}</Accordion.Panel>
              </Accordion.Item>
            );
          })}
        </Accordion>
      </main>
      <LinkButton to="/" text={t('common.backToHome')} />

      <footer
        style={{ backgroundImage: `url(${FooterBackGroundImage})` }}
      ></footer>
    </article>
  );
};
